var _templateObject;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import { styled } from '@creditas-ui/system';
import * as React from 'react';
import { Toaster as DefaultToaster } from 'react-hot-toast';
function getWindowDimensions() {
  var {
    innerWidth: width,
    innerHeight: height
  } = window;
  return {
    width,
    height
  };
}
function useWindowDimensions() {
  var [windowDimensions, setWindowDimensions] = React.useState(getWindowDimensions());
  React.useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  return windowDimensions;
}
var CheckIsMobile = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: none;\n  ", "\n"])), _ref => {
  var {
    theme,
    width,
    setIsMobile
  } = _ref;
  var breakpoint = Number(theme.breakpoints['2xl'].replace(/px/i, ''));
  if (width > breakpoint) setIsMobile(false);else setIsMobile(true);
  return null;
});
var Toaster = props => {
  var [isMobile, setIsMobile] = React.useState(false);
  var {
    width
  } = useWindowDimensions();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CheckIsMobile, {
    width: width,
    setIsMobile: setIsMobile
  }), /*#__PURE__*/React.createElement(DefaultToaster, _extends({
    position: isMobile ? 'top-center' : 'bottom-center'
  }, props)));
};
export { Toaster };
//# sourceMappingURL=Toaster.js.map